
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.25 19.495h-5.8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5.8c.41 0 .75.34.75.75s-.34.75-.75.75z"}}),_c('path',{attrs:{"d":"M2.45 19.475c-.1 0-.21 0-.32-.02A2.467 2.467 0 010 17.065V2.255C0 1.015 1.01.005 2.25.005h4.5C7.99.005 9 1.015 9 2.255v.75h9.75c1.24 0 2.25 1.01 2.25 2.25v2.25h.75c.69 0 1.36.33 1.78.88.42.55.57 1.28.39 1.95a.75.75 0 11-1.45-.39c.06-.22.01-.47-.13-.65a.758.758 0 00-.6-.29H7.87a.75.75 0 00-.72.54l-2.35 8.15a2.46 2.46 0 01-2.36 1.78h.01zm-.2-17.98c-.41 0-.75.34-.75.75v14.8c0 .46.36.86.83.92.46.07.91-.23 1.04-.68l2.35-8.16c.28-.96 1.17-1.63 2.16-1.63H19.5v-2.25c0-.41-.34-.75-.75-.75H8.25c-.41 0-.75-.34-.75-.75v-1.5c0-.41-.34-.75-.75-.75h-4.5z"}}),_c('path',{attrs:{"d":"M17.25 23.995c-3.72 0-6.75-3.03-6.75-6.75s3.03-6.75 6.75-6.75 6.75 3.03 6.75 6.75-3.03 6.75-6.75 6.75zm0-12c-2.9 0-5.25 2.36-5.25 5.25s2.35 5.25 5.25 5.25 5.25-2.36 5.25-5.25-2.35-5.25-5.25-5.25z"}}),_c('path',{attrs:{"d":"M13.01 22.235c-.19 0-.38-.07-.53-.22a.754.754 0 010-1.06l8.48-8.48c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-8.48 8.48c-.15.15-.34.22-.53.22z"}})])
          )
        }
      }
    